/**
 * For the logic here, refer to: sources/core-embed/core-embed-application/src/main/java/com/axpm/modules/patient/businessportal/ui/tx/entry/AppointmentEntryView.java
 * @param {string} action
 * @param {string} booking_datetime
 * @returns
 */
export function getTitle(action, booking_datetime) {
  switch (action) {
    case 'OFFICE_CANCELLED':
    case 'PATIENT_CANCELLED':
      return 'Cancelled'

    case 'SCHEDULED':
      return `Scheduled for ${booking_datetime}`
    case 'RESCHEDULED':
      return `Rescheduled for ${booking_datetime}`
    case 'NO_SHOW':
      return `Patient didn't show up for ${booking_datetime}`
    case 'CREATED':
      return 'Appointment created'

    default:
      return action
  }
}
